<template>
  <header :class="['shop-header', isHubspotIntegrationEnabled && 'shop-header--absolute-position']">
    <Logo class="shop-header__logo" />
    <div class="shop-header__nav-buttons" v-if="!isOnePlanAvailable">
      <router-link
        v-if="showHeaderBackBtn"
        :to="{ name: 'shop' }"
        class="btn btn--secondary header__cta"
      >
        {{ backBtnLabel }}
      </router-link>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Logo from '@/assets/icons/ine-logo.svg'
import { routesRules } from '@/helpers/mixins/routesRules'

export default {
  name: 'ShopHeader',
  mixins: [routesRules],
  components: {
    Logo: { ...Logo, name: 'Logo' },
  },
  computed: {
    ...mapState({
      isOnePlanAvailable: state => state.products.isOnePlanAvailable,
    }),
    ...mapGetters({
      isBlackFridayActive: 'app/isBlackFridayActive',
      isHubspotIntegrationEnabled: 'featureFlags/isHubspotIntegrationEnabled',
    }),
    backBtnLabel() {
      if (this.isBooGoPage || this.isBlackFridayActive) return 'See all plans'
      return 'Back to shop'
    },
  },
}
</script>

<style lang="scss" scoped>
.shop-header {
  &--absolute-position {
    position: absolute;
    top: 0;
  }
  width: 100%;
  display: flex;
  align-items: center;
  background: var(--charcoal-gradient);
  z-index: 3;
  display: flex;
  justify-content: space-between;
  @include font-book;
  padding: 20px;
  @include tablet {
    padding: 20px 50px;
  }
  @include lg-desktop {
    position: absolute;
  }
  &__logo {
    width: 85px;
  }
  &__nav-buttons {
    @include mobile {
      display: flex;
      gap: 10px;
    }
  }
}
</style>
